export default {
    setScreenMode(state, mode) {
        state.screenMode = mode
    },
    initComplite(state) {
        state.loaded = true
    }
}
